import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { useVertical } from "@/contexts/VerticalContext"
import { Layers } from "lucide-react"

const VERTICALS = [
  { value: "all", label: "All Verticals" },
  { value: "real_estate", label: "Real Estate" },
  { value: "home_services", label: "Home Services" },
]

export function VerticalFilter() {
  const { vertical, setVertical } = useVertical()

  return (
    <Select
      value={vertical || "all"}
      onValueChange={(v) => setVertical(v === "all" ? null : v)}
    >
      <SelectTrigger className="h-7 w-[140px] text-2xs gap-1 border-border/50">
        <Layers className="h-3 w-3 text-muted-foreground shrink-0" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {VERTICALS.map((v) => (
          <SelectItem key={v.value} value={v.value} className="text-xs">
            {v.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
